import { amazonConnectApi } from '../api/amazonconnect';

/** Dashboard refresh may pull these from Amazon. Never reports / all_orders. */
export const DUE_ORDER_DOMAINS = ['orders', 'order_items'] as const;

export function dueOrderSyncBody(domain: (typeof DUE_ORDER_DOMAINS)[number]) {
  return { domain, if_due: true as const };
}

/** Initial dashboard paint reads stored data; Amazon pulls require an explicit refresh. */
export function shouldPullDueOrderDomains(connectionId: string, refreshToken: number): boolean {
  return refreshToken > 0 && connectionId.trim().length > 0;
}

/** Best-effort due V2 orders + order_items. Failures do not block Gate A re-read. */
export async function pullDueOrderDomains(connectionId: string): Promise<void> {
  const id = connectionId.trim();
  if (!id) return;
  await Promise.all(
    DUE_ORDER_DOMAINS.map((domain) =>
      amazonConnectApi.spapiV2Sync(id, domain, { ifDue: true }).catch(() => undefined),
    ),
  );
}
